import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const InfoWrapper = styled.div`
  display: flex;

  & > div:first-child {
    margin-right: 8px;
  }

  & > div:last-child > div {
    margin-bottom: 14px;
  }
`;

export const FormItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin-right: 48px;
  }
`;

export const MainWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;

  & > div:last-child {
    margin-left: 16px;
    cursor: pointer;
    align-self: flex-start;
    margin-top: 33px;
  }
`;

export const RoundColorLabel = styled.div`
  background: ${({ color }: { color: string }) => color};
  width: 16px;
  height: 16px;
  border-radius: 100%;
  margin-right: 8px;
`;

export const InfoWrapperItem = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledBillableButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 288px;
  .ant-form-item {
    width: 50px;
  }

  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const StyledLabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  gap: 4px;
  width: 100%;
  :hover {
    cursor: pointer;
  }
`;
